/* eslint-disable no-unused-vars */
export enum UICheckboxVariants {
    login = 'login',
    allInclusiveCF = 'allInclusiveCF',
  };
